var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivacy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.50003,
    r: 9.5,
    fill: "#546EDB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4C6.46734 4 4 6.46734 4 9.5C4 12.5327 6.46734 15 9.5 15C12.5327 15 15 12.5327 15 9.5C15 6.46734 12.5326 4 9.5 4ZM9.85776 12.7633C9.59646 12.8068 9.07652 12.9156 8.81249 12.9375C8.58901 12.956 8.37811 12.8281 8.24954 12.6444C8.12065 12.4608 8.08976 12.2258 8.16628 12.015L9.20592 9.15626H8.12499C8.12407 8.56057 8.57088 8.12258 9.14235 7.95448C9.41506 7.87424 9.92316 7.76444 10.1875 7.78127C10.3458 7.79134 10.6219 7.89069 10.7504 8.07434C10.8793 8.25796 10.9102 8.49295 10.8337 8.70376L9.79405 11.5625H10.8747C10.8749 12.1575 10.4447 12.6655 9.85776 12.7633ZM10.1875 7.43751C9.80778 7.43751 9.49998 7.12966 9.49998 6.75C9.49998 6.37029 9.80778 6.06249 10.1875 6.06249C10.5672 6.06249 10.875 6.37029 10.875 6.75C10.875 7.12969 10.5672 7.43751 10.1875 7.43751Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacy);
export default __webpack_public_path__ + "static/media/privacy.dc4743773bb136c8ab591bdb01164c84.svg";
export { ForwardRef as ReactComponent };